import React from 'react';
import LazyLoad from 'react-lazy-load';
import Dotdotdot from 'react-dotdotdot';
import PropTypes from 'prop-types';
import { getVideoObjectImage, getVideoObjectImages } from 'helpers/VideoProcessorHelper';
import { helperGetRelativeUrl } from 'helpers/RouteHelper';
import { Link } from 'react-router';
import Image from './components/Image';
import NetworkImage from './components/NetworkImage';
import theme from './style.css';

const ShowsTile = props => {
  const { item, breakpoint } = props;
  if (!item) return null;

  const {
    detailUrl,
    images,
    name,
    network,
    playerScreenUrl,
    screenUrl,
    seriesName,
    seriesScreenUrl,
  } = item;

  const title = seriesName || name;
  const imageObj = getVideoObjectImages({ images });
  const image = getVideoObjectImage({ image: imageObj, network });
  const url = screenUrl || seriesScreenUrl || playerScreenUrl || detailUrl;
  const link = helperGetRelativeUrl({ url });

  return (
    <div className={theme.tile}>
      <Link to={link}>
        <div className={theme.imageContainer}>
          <LazyLoad offset={100} debounce={false} throttle={350} unmountIfInvisible once>
            <Image src={image} breakpoint={breakpoint} />
          </LazyLoad>
          <div className={theme.networkImage}>
            <NetworkImage network={network} />
          </div>
        </div>
      </Link>

      <Dotdotdot clamp={1}>
        <Link to={link} className={theme.title}>
          {title}
        </Link>
      </Dotdotdot>
    </div>
  );
};

ShowsTile.propTypes = {
  item: PropTypes.shape({
    network: PropTypes.string.isRequired,
    detailUrl: PropTypes.string,
    images: PropTypes.shape({}),
    name: PropTypes.string,
    playerScreenUrl: PropTypes.string,
    screenUrl: PropTypes.string,
    seriesName: PropTypes.string,
    seriesScreenUrl: PropTypes.string,
  }).isRequired,
  breakpoint: PropTypes.string.isRequired,
};

export default ShowsTile;
